import { createSelector } from 'reselect';
export const getLoaderState = (state) => state.ui.loader;
export const getLoader = createSelector([getLoaderState], (loaderState) => (loaderName) => loaderState.loaders[loaderName] || false);
//# sourceMappingURL=loader.selector.js.map